import { Injectable } from '@angular/core';
import * as html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

@Injectable({
    providedIn: 'root'
})
export class PdfService {

    constructor() { }

    public async downloadElementAsPDF(elementId: string, fileName: string): Promise<void> {
        const element = document.getElementById(elementId);

        if (!element) {
            console.error(`Element with id ${elementId} not found`);
            return;
        }

        try {
            // Handle html2canvas import (namespace vs default)
            const h2c: any = html2canvas;
            const html2canvasFunc = h2c.default || h2c;

            // Use html2canvas to capture the element as an image
            const canvas = await html2canvasFunc(element, {
                scale: 2, // Increase scale for better resolution
                useCORS: true, // Enable CORS to capture images from other domains if needed
                logging: false, // Disable logging
                allowTaint: true,
                backgroundColor: '#ffffff' // Ensure white background
            } as any);

            const imgData = canvas.toDataURL('image/png');

            // Calculate dimensions to fit A4 paper
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            // Add the first page
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            // Add additional pages if the content is longer than one page
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(fileName);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    }
}
